import "./styles.css";
import { CSSProperties, useEffect, useRef, useState } from "react";
import { Modal } from "../../../../../Modal/Default/Index";
import { ButtonOnlyTitle } from "../../../../../Buttons/ButtonOnlyTitle/Index";
import { useTaskCreation } from "../../../../../../hooks/useTaskCreation";
import { RoundedCloseButton } from "../../../../../Buttons/RoundedCloseButton/Index";
import { ReactComponent as CheckComplete } from "../../../../../../assets/svg/icons/CheckFull.svg";
import axios from "../../../../../../services/axios";
import { useTranslation } from "react-i18next";

const createEvaluatorModalStyle = {
  padding: "50px",
  width: "600px",
  height: "fit-content",
  borderRadius: 20,
  position: "relative",
} as CSSProperties;

const createEvaluatorMobileModalStyle = {
  ...createEvaluatorModalStyle,
  padding: "32px 24px",
  width: "calc(100vw - 32px)",
  maxHeight: "calc(100vh - 32px)",
  borderRadius: 16,
  overflow: "hidden",
} as CSSProperties;

export default function StartEvaluation() {
  const { t } = useTranslation();
  const { modalStartEvaluator, setModalStartEvaluator } = useTaskCreation();
  const [modalEvaluationStarted, setModalEvaluationStarted] =
    useState<boolean>(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const requestInFlightRef = useRef(false);
  const [isMobile, setIsMobile] = useState<boolean>(() => {
    if (typeof window === "undefined") return false;
    return window.innerWidth <= 768;
  });

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  async function submitStartEvaluation() {
    if (requestInFlightRef.current) return;

    requestInFlightRef.current = true;
    setIsSubmitting(true);

    try {
      await axios.post("tasks/pasture-evaluation/assign");
      setModalStartEvaluator(false);
      setModalEvaluationStarted(true);
    } catch (err) {
      console.error(err);
    } finally {
      requestInFlightRef.current = false;
      setIsSubmitting(false);
    }
  }

  return (
    <>
      <Modal
        visible={modalStartEvaluator}
        contentStyle={
          isMobile ? createEvaluatorMobileModalStyle : createEvaluatorModalStyle
        }
      >
        <div className="closeButton__startEvaluation">
          <RoundedCloseButton
            disabled={isSubmitting}
            onClick={() => {
              setModalStartEvaluator(false);
            }}
          />
        </div>
        <section className="body__startEvaluation">
          <header>
            <h2 className="title__startEvaluation">{t("managementDialogs.startEvaluation")}</h2>
            <span className="description__startEvaluation">
              Ao iniciar a avaliação de pastagem, você irá gerar uma tarefa
              referente a todos os pastos com avaliador cadastrado, que ainda
              não possuem tarefa de avaliação de pastagem iniciada.
            </span>
          </header>
          <footer className="footerCreateEvaluator">
            <ButtonOnlyTitle
              title={t("commonUi.cancel")}
              theme="light"
              type="button"
              onClick={() => setModalStartEvaluator(false)}
              disabled={isSubmitting}
              style={{ minWidth: 300, minHeight: 42 }}
            />
            <ButtonOnlyTitle
              title={t("managementDialogs.start")}
              theme="info"
              type="button"
              onClick={submitStartEvaluation}
              disabled={isSubmitting}
              style={{ minWidth: 300, minHeight: 42 }}
            />
          </footer>
        </section>
      </Modal>

      <Modal
        visible={modalEvaluationStarted}
        contentStyle={
          isMobile ? createEvaluatorMobileModalStyle : createEvaluatorModalStyle
        }
      >
        <div className="closeButton__startEvaluation">
          <RoundedCloseButton
            onClick={() => {
              setModalEvaluationStarted(false);
            }}
          />
        </div>
        <section className="body__startEvaluation">
          <CheckComplete />
          <header>
            <h2 className="title__startEvaluation">{t("managementDialogs.evaluationStarted")}</h2>
            <span className="description__startEvaluation">
              Para avaliar novamente você pode reiniciar a avaliação.
            </span>
          </header>
          <footer className="footerCreateEvaluator">
            <ButtonOnlyTitle
              title={t("editFooter.complete")}
              theme="info"
              type="button"
              onClick={() => {
                setModalEvaluationStarted(false);
                setModalStartEvaluator(false);
              }}
            />
          </footer>
        </section>
      </Modal>
    </>
  );
}
